export default __webpack_public_path__ + "static/media/logo.5c1a6d9b.png";